import { LAYOUT } from '@admin/router/constant'

// 物料开发单
const materialDevelopmentSheetRouter = {
  path: '/materialDevelopmentSheet',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/sample-management/sample-development-order',
      name: 'sampleDevelopmentOrder',
      component: () => import('@admin/views/plm/sampleManagement/sampleDevelopmentOrder/index.vue'),
      meta: { helpUrl: '', title: '样版开发单' },
    },
    {
      path: '/sample-development-order/detail',
      name: '',
      component: () => import('@admin/views/plm/newDesign/detail/index.vue'),
      meta: { helpUrl: '', title: '样版开发单详情' },
    },
    {
      path: '/sample-management/paper-purchase-order',
      name: 'paperPurchaseOrder',
      component: () => import('@admin/views/plm/sampleManagement/paperPurchaseOrder/index.vue'),
      meta: { helpUrl: '', title: '版料采购单' },
    },
    {
      path: '/paper-purchase-order/detail',
      name: '',
      component: () => import('@admin/views/plm/newDesign/detail/index.vue'),
      meta: { helpUrl: '', title: '版料采购单详情' },
    },
    {
      path: '/sample-management/secondary-process-order',
      name: 'secondaryProcessOrder',
      component: () => import('@admin/views/plm/sampleManagement/secondaryProcessOrder/index.vue'),
      meta: { helpUrl: '', title: '特殊二次工艺单' },
    },
    {
      path: '/secondary-process-order/detail',
      name: '',
      component: () => import('@admin/views/plm/newDesign/detail/index.vue'),
      meta: { helpUrl: '', title: '特殊二次工艺单详情' },
    },
  ],
}

export default materialDevelopmentSheetRouter
